import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import Icon from '@xo-union/tk-component-icons';
import styles from './missing-info-dropdown.scss';

export default class MissingInfoDropdown extends React.Component {
  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState),
    showCheckmark: PropTypes.bool,
    border: PropTypes.bool,
    addressFilter: PropTypes.bool,
  };

  showCheckmark(category) {
    const { addressFilter, showCheckmark = false } = this.props;

    return category === 'Address' && showCheckmark && addressFilter;
  }

  handleClick(category) {
    const { gdsUiState, addressFilter } = this.props;

    if (category === 'Address') {
      gdsUiState.setAddressFilter(!addressFilter);
    }
  }

  render() {
    const missingInfoCategories = ['Address'];
    const { border = false } = this.props;

    return (
      <Fragment>
        {missingInfoCategories.map(category => {
          return (
            <div
              key={category}
              className={classnames(styles.missingInfoDropdownCell, {
                [styles.missingInfoDropdownCellWithBorder]: border,
              })}
              onKeyDown={e => (e.key === 'Enter' ? this.handleClick(category) : null)}
              onClick={() => this.handleClick(category)}
              tabIndex={0}
            >
              <span>{category}</span>
              {this.showCheckmark(category) && <Icon className={styles.check} name="checkmark" />}
            </div>
          );
        })}
      </Fragment>
    );
  }
}
